import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PtlXhrModule } from '@ptl/xhr';
import { StateModule, StateModuleReadyService } from '@ptl/state';
import { PtlGlobalComponentsModule } from '@ptl/global-components';
import { PreLoginAppStatusComponent } from './components/pre-login-app-status.component';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { createCustomElement } from '@angular/elements';
import { PtlBrandModule } from '@ptl/brand';

@NgModule({
  declarations: [
    PreLoginAppStatusComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PtlXhrModule,
    StateModule,
    PtlBrandModule,
    PtlGlobalComponentsModule,
    MaterialGlobalModule
  ],
  exports: [PreLoginAppStatusComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PreLoginAppStatusModule {

  constructor(
    private injector: Injector,
    private stateModuleReadyService: StateModuleReadyService
  ) {
    // console.log("PreLoginAppStatusModule - constructor");
    this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
      if (isReady) {
        this.createElementIfDoesNotExist('sxe-pre-login-app-status', PreLoginAppStatusComponent);
      }
    });
  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, {
        injector: this.injector
      });
      customElements.define(elementName, customElement);
    }
  }
}
